import React from 'react'
import JobCardComponent from './jobCard';

const JobList = ({ ...props }) => {

  return (
    <JobCardComponent
      {...props}
      skills={props?.allSkills}
      title={props?.title}
      summary={props?.summary}
      jobSkills={props?.skills}
      expNeeded={props?.expNeeded}
      timezone={props?.timezone}
      overlappingNeededHours={props?.overlappingNeededHours}
      expectedStartDate={props?.expectedStartDate}
      createdAt={props?.createdAt}
      logo={props?.businessId?.logo || ""}
    />
  )
}

export default JobList;
